import { render, staticRenderFns } from "./TagCompare.vue?vue&type=template&id=2d1b3a1c&scoped=true"
import script from "./TagCompare.vue?vue&type=script&lang=js"
export * from "./TagCompare.vue?vue&type=script&lang=js"
import style0 from "./TagCompare.vue?vue&type=style&index=0&id=2d1b3a1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1b3a1c",
  null
  
)

export default component.exports